<template>
    <div id="app" :class="backgroundColor" v-if="isAuthenticated">
        <the-header/>
        {{ $refs.currentcomopnent }}
        <router-view ref="currentcomponent" :key="$route.fullpath" class="main-content"/>
        <the-footer class="footer mt-5"/>

        <b-modal
            id="inactive-modal"
            centered
            hide-header
            hide-footer
        >
            <div class="text-center">
                <img class="mb-3" src="@/assets/icons/error.svg" alt="error">
                <p class="mb-3">{{ $t('inactive.forMinutes', {minutes}) }}</p>
                <p class="mb-3">{{ $t('inactive.secondsLeft', {seconds: time}) }}</p>
            </div>
        </b-modal>

    </div>
</template>

<script>
    import TheHeader from "@/components/TheHeader";
    import {mapGetters} from "vuex";
    import TheFooter from "@/components/TheFooter";
    import {IDLE_TIME_MILLISECONDS, IDLE_TIME_WARNING_SECONDS} from "@/vue-idle/vue-idle-config";

    export default {
        components: {
            TheFooter,
            TheHeader,
        },
        data() {
            return {
                time: IDLE_TIME_WARNING_SECONDS,
                timer: null,
            };
        },
        computed: {
            ...mapGetters([
                'isAuthenticated'
            ]),
            backgroundColor() {
                if (this.$route.name === 'home') {
                    return '';
                }
                return 'main-background';
            },
            minutes() {
                return IDLE_TIME_MILLISECONDS / 60000;
            },
        },
        watch: {
            isAppIdle(newValue) {
                if (newValue) {
                    this.showInactiveModal();
                }
            }
        },
        methods: {
            showInactiveModal() {
                let timerId = setInterval(() => {
                    this.time -= 1;
                    if (!this.isAppIdle) {
                        clearInterval(timerId);
                        this.closeInactiveModal();
                    }
                    if (this.time < 1) {
                        clearInterval(timerId);
                        this.closeInactiveModal();
                        location.replace(process.env.VUE_APP_SERVERURL + 'api-auth/logout/');
                    }
                }, 1000);
                this.$bvModal.show('inactive-modal');
            },
            closeInactiveModal() {
                this.time = IDLE_TIME_WARNING_SECONDS;
                this.$bvModal.hide('inactive-modal');
            }
        },
    };
</script>

<style lang="scss">
    @import "src/custom";
    #app {
        min-height: 100vh;
        position: relative;
    }

    .main-content {
        padding-bottom: 120px;
    }

    .footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 70px;
    }

    .card-header {
        background-color: $primary;
        color: white;
        font-weight: bold;
    }

    .sidebar-background {
        background-color: $color4;
    }

    .error {
        color: red;
    }
</style>
